import React, {useEffect, useState} from 'react';
import {View, Text, Platform, PixelRatio} from 'react-native';
import {SvgProps} from 'react-native-svg';

import {IconName, IconList} from './iconSource';

interface IconProps {
  name: IconName;
  size?: number;
  width?: number;
  height?: number;
}

const SVGIcon = (props: IconProps) => {
  const {name = 'lock', size = 24, width = size, height = size} = props;
  const [Icon, setIcon] = useState<React.FC<SvgProps>>();
  const getFixedSize = (size: number) => PixelRatio.roundToNearestPixel(size);

  const updateIcon = () => {
    setIcon(IconList[name]);
  };

  useEffect(() => {
    updateIcon();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  if (!Icon) {
    return null;
  }

  const fixedWidth = getFixedSize(width);
  const fixedHeight = getFixedSize(height);

  return (
    <View
      style={{
        width: width,
        height: height,
      }}>
        {
          Platform.OS === 'web' ?
          (
            <Text><Icon /></Text>
          ) : (
             <View style={{width: fixedWidth, height: fixedHeight, justifyContent: 'center', alignItems: 'center'}}>
              {Icon}
             </View>
          )
        }
    </View>
  );
};

export default React.memo(SVGIcon);
